import actions from './actions';
import types from './types';

const pageAnalyticsModule = {
  state: () => ({
    analytics: null,
    analyticsLoading: false,
    error: null,
  }),
  mutations: {
    [types.GET_PAGE_ANALYTICS_START]: (state) => {
      state.analyticsLoading = true;
      state.error = null;
    },
    [types.GET_PAGE_ANALYTICS_SUCCESS]: (state, data) => {
      state.analytics = data;
      state.analyticsLoading = false;
      state.error = null;
    },
    [types.GET_PAGE_ANALYTICS_FAILURE]: (state) => {
      state.analyticsLoading = false;
      state.error = 'Failed to load analytics';
    },
  },
  actions,
  namespaced: true,
};

export default pageAnalyticsModule;
